<template>
	<div ref="box" style="height:100%;">
		
		
		<div id="editor" style="height:100%;"></div>
	</div>
</template>

<script>
	// 引入 wangEditor
    import wangEditor from 'wangeditor'
    
	export default {
		data() {
			return {
				editor: null,
				editorData: ''
			}
        },
        props: {
			value: String
		},
        watch:{
	
            value:{
				immediate:true,
				handler(val){
					if (val) {
						if (val !== this.editorData) {
						this.setContent(val);
						}
					} else {
						this.setContent('');
					}
				}
			},
            editorData:function(news){
                this.$emit("input",news);
            }
        },
		mounted() {
			const editor = new wangEditor(`#editor`)
            // 配置 onchange 回调函数，将数据同步到 vue 中
            
			
			editor.config.onchange = (newHtml) => {
				this.editorData = newHtml;
			}
			
			
			let this_ = this;
			editor.config.onblur = function () {
				this_.$emit("blur")
			}
			editor.config.menus = [
				'bold',
			
				'italic',
				'justify',
				'lineHeight'
			]
			
            editor.create()
            editor.txt.html(this.editorData)
			
			this.editor = editor
			this.lastFocus();
			editor.config.height = 600;
			console.log(this.$refs.box,this.$refs.box.clientHeight,this.$refs.box.offsetHeight)
		},
		methods: {
			setContent(val) {
				this.editorData = val;
				if(this.editor){
					this.editor.txt.html(val);
					
					this.lastFocus();
				}
				
			},
			lastFocus(){
				this.editor.selection.moveCursor(this.editor.$textElem.elems[0],false);
			}
		},
		beforeDestroy() {
			// 调用销毁 API 对当前编辑器实例进行销毁
			this.editor.destroy()
			this.editor = null
		}
	}
</script>

<style lang="scss" scoped>
	.home {
		width: 1200px;
		margin: auto;
		position: relative;

		.btn {
			position: absolute;
			right: 0;
			top: 0;
			padding: 5px 10px;
			cursor: pointer;
		}

		h3 {
			margin: 30px 0 15px;
		}
	}
	/deep/ .w-e-icon-fullscreen{display:none;}
	/deep/ .w-e-menu>.w-e-icon-paragraph-left::before{content:"对齐";}
	/deep/ .w-e-menu>.w-e-icon-row-height::before{content:"行距";}
	/deep/ .w-e-text-container{
		height: calc(100% - 86px) !important;
	}
</style>